import { useMemo, useState } from "react";
import moment from "moment-jalaali";

import DBInput from "../DBInput";
import DatePickerModal from "../DatePicker";

const toMiladiDate = (jalaliDateStr) => {
    // jalaliDateStr format: YYYY-MM-DD (e.g. 1403-05-10)
    if (!jalaliDateStr) return "";
    // moment-jalaali doesn't support `moment.from`. We parse using Jalali format tokens.
    return moment(jalaliDateStr, "jYYYY-jMM-jDD").format("YYYY-MM-DD");
};

const parseMiladiDateTime = (miladiDateTimeStr) => {
    // expected format: YYYY-MM-DDTHH:mm (timezone-less, like the current datetime-local usage)
    if (!miladiDateTimeStr) {
        return { miladiDate: "", jalaliDate: "", time: "" };
    }

    const m = moment(miladiDateTimeStr);
    return {
        miladiDate: m.format("YYYY-MM-DD"),
        jalaliDate: m.format("jYYYY-jMM-jDD"),
        time: m.format("HH:mm"),
    };
};

export default function JalaliDateTimeInput({
    value,
    onChange,
    disabled,
}) {
    const [datePickerOpen, setDatePickerOpen] = useState(false);

    const parsed = useMemo(() => parseMiladiDateTime(value), [value]);
    const jalaliDate = parsed.jalaliDate;
    const time = parsed.time;

    const defaultPickerValue = useMemo(() => {
        // If no date selected yet, start picker at today in Jalali.
        return jalaliDate || moment().format("jYYYY-jMM-jDD");
    }, [jalaliDate]);

    return (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <DBInput
                type="text"
                size="large"
                autoComplete="off"
                disabled={disabled}
                readOnly
                value={jalaliDate}
                placeholder="YYYY-MM-DD"
                onClick={() => {
                    if (disabled) return;
                    setDatePickerOpen(true);
                }}
            />

            <DBInput
                type="time"
                size="large"
                autoComplete="off"
                disabled={disabled || !jalaliDate}
                value={time}
                onChange={(e) => {
                    const nextTime = e.target.value;
                    if (!parsed.miladiDate) return;
                    const next = `${parsed.miladiDate}T${nextTime}`;
                    onChange?.(next);
                }}
            />

            <DatePickerModal
                show={datePickerOpen}
                close={setDatePickerOpen}
                defaultValue={defaultPickerValue}
                onChange={(dateParts) => {
                    // dateParts: { fa: "1403-05-10", en: "2024-..." }
                    const nextMiladiDate = toMiladiDate(dateParts?.fa);
                    if (!nextMiladiDate) return;
                    const nextTime = time || "00:00";
                    onChange?.(`${nextMiladiDate}T${nextTime}`);
                }}
            />
        </div>
    );
}

